import { Wrapper } from './Tag.styles';

export type TagColorType =
  | 'black'
  | 'blue'
  | 'mediumGray'
  | 'green'
  | 'lightGray'
  | 'lightGreen'
  | 'orange'
  | 'purple'
  | 'red'
  | 'yellow';

export interface TagProps {
  className?: string;
  color?: TagColorType;
  onClick?: () => void;
  text?: string;
  tooltip?: string;
  unSelected?: boolean;
}
const Tag = ({
  className,
  color,
  onClick,
  text,
  tooltip,
  unSelected = false,
}: TagProps): JSX.Element => {
  return (
    <Wrapper
      className={className}
      color={color}
      data-tip={tooltip}
      unSelected={unSelected}
      onClick={onClick}
    >
      {text}
    </Wrapper>
  );
};

export default Tag;
